import React from 'react';
import { Stack } from '../../../atoms/stack/Stack';
import { Typography } from '../../../atoms/typography/Typography';
import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

const InfoCardItem = ({ data }) => (
  <div className="flex w-full flex-col md:flex-row min-h-96 bg-white rounded-[48px] shadow-lg p-12 md:p-20 gap-10">
    <Stack className="flex-1 md:flex-[0.5] lg:flex-[0.33] h-full items-center self-center gap-10">
      {data.iconImg}
      <Typography as="h3" fontVariant="h6">
        {data.title}
      </Typography>
    </Stack>
    <Stack className="flex-1 md:flex-[0.5] md:flex-[0.67] md:max-w-md h-full items-center self-center gap-5">
      <StyledHtmlDiv
        className="text-clamp-lg font-light normal-case text-left"
        content={data.text}
      />
    </Stack>
  </div>
);

export default InfoCardItem;
